import ropstenAsset from './ropstenTestnet.ethereum.json'
import kovanAsset from './kovanTestnet.ethereum.json'
import maticAsset from './maticTestnet.ethereum.json'
import bscAsset from './bsc.mainnet.json'
import avaxFujiAsset from './avax.testnet.json'
import avaxAsset from './avax.mainnet.json'
import okexAsset from './okex.testnet.json'
import ethereumAsset from './ethereum.mainnet.json'
import polgonAsset from './polygon.mainnet.json'
import ftmAsset from './ftm.mainnet.json'
import arbitrumAsset from './arbitrum.mainnet.json'
import optimismAsset from './optimism.mainnet.json'
import { AssetType, ChainId } from '../../types'

 export const ASSET_LIST:{[chainId:string]:AssetType[]} = {
    [ChainId.KOVAN]: kovanAsset,
    [ChainId.MUMBAI]: maticAsset,
    [ChainId.BSC]: bscAsset,
    [ChainId.AVALANCHE]: avaxAsset,
    [ChainId.FUJI]: avaxFujiAsset,
    [ChainId.MAINNET]: ethereumAsset,
    [ChainId.POLYGON]: polgonAsset,
    [ChainId.FANTOM]: ftmAsset,
    [ChainId.ARBITRUM]: arbitrumAsset,
    [ChainId.OPTIMISM]: optimismAsset,
    [ChainId.ROPSTEN]: ropstenAsset,
    [ChainId.OKEX]: okexAsset,
  }